import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { createAutocomplete } from '@algolia/autocomplete-core';
import { Input } from 'antd';

// Mapeie seu idioma para os arquivos correspondentes
const localeMap = {
  en: require('./search-data/en_US.json'),
  pt: require('./search-data/pt_BR.json'),
  // fr: require('./search-data/fr_FR.json'),
  // es: require('./search-data/es_ES.json'),
  // tr: require('./search-data/tr_TR.json'),
};

export default function HeaderSearch(props) {
  const [autocompleteState, setAutocompleteState] = useState({});

  // Pega o idioma do Redux
  const language = useSelector((state) => state.customise.language);
  const pagesJson = localeMap[language] || [];

  // Hook do react-intl para traduzir
  const intl = useIntl();
  const placeholderText = intl.formatMessage({ id: 'header-search' });

  const autocomplete = useMemo(
    () =>
      createAutocomplete({
        onStateChange({ state }) {
          setAutocompleteState(state);
        },
        getSources() {
          return [
            {
              sourceId: 'pages-source',
              getItemInputValue({ item }) {
                return item.query;
              },
              getItems({ query }) {
                if (!query) {
                  return pagesJson;
                }
                return pagesJson.filter((item) =>
                  item.title.toLowerCase().includes(query.toLowerCase())
                );
              },
              getItemUrl({ item }) {
                return item.url;
              },
              templates: {
                item({ item }) {
                  return item.title;
                },
              },
            },
          ];
        },
      }),
    [pagesJson] // Atualiza quando o idioma mudar
  );

  function linkHandleClick() {
    autocompleteState.query = '';
    props.setSearchHeader(false);
  }

  return (
    <div {...autocomplete.getRootProps({})}>
      <Input
        {...props.inputFocusProp}
        {...autocomplete.getInputProps({})}
        placeholder={placeholderText}
        prefix={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* ...SVG code */}
          </svg>
        }
      />

      <div
        className="hp-header-search-result"
        {...autocomplete.getPanelProps({})}
      >
        {autocompleteState.isOpen &&
          autocompleteState.collections.map((collection, index) => {
            const { source, items } = collection;

            return (
              items.length > 0 && (
                <ul key={index} {...autocomplete.getListProps()}>
                  {items.map(
                    (item, index) =>
                      index < 4 && (
                        <li
                          key={index}
                          {...autocomplete.getItemProps({
                            item,
                            source,
                          })}
                          className="hp-font-weight-500"
                        >
                          <Link to={item.url} onClick={linkHandleClick}>
                            {item.title}
                          </Link>
                        </li>
                      )
                  )}
                </ul>
              )
            );
          })}
      </div>
    </div>
  );
}
